import PropTypes from "prop-types"
import { useEffect } from "react"
import { useCustomNavigationLabel } from "source/publishing/WebBoot"
import useReactNativeBridgeComponent from "source/shared/hooks/useReactNativeBridgeComponent"

NativeHeader.propTypes = {
  hideBottomDrawer: PropTypes.bool,
  rightType: PropTypes.oneOf(["default", "share"]),
  shareUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
}
export default function NativeHeader({
  hideBottomDrawer,
  title,
  rightType,
  shareUrl,
}) {
  const navTitle = useCustomNavigationLabel(title)
  const { postMessage } = useReactNativeBridgeComponent({
    component: NativeHeader.nativeComponentName,
  })
  useEffect(() => {
    postMessage("set", {
      hideBottomDrawer,
      title: navTitle,
      right: {
        type: rightType,
        shareUrl,
      },
    })
  }, [hideBottomDrawer, postMessage, rightType, shareUrl, navTitle])

  return null
}
NativeHeader.nativeComponentName = "NativeNavigationOptions"
